module.exports = "<coverage-legend-item *ngFor=\"let item of legendsToShow\" [legendInfo]=\"item\"></coverage-legend-item>";


//////////////////
// WEBPACK FOOTER
// ./src/typescript/coverage-modal/coverage-legend.component.html
// module id = 1083
// module chunks = 1